<template>
    <div>
        <div
            class="d-flex align-items-center pb-1"
            :class="{ 'padding-child': !hasChild }"
        >
            <i
                v-if="hasChild"
                ref="iconAccordion"
                :class="
                    isCollapsed
                        ? 'cus-control-play-blue-down'
                        : 'cus-control-play-blue'
                "
                style="vertical-align: inherit;"
                @click="isCollapsed = !isCollapsed"
            ></i>

            <span
                @click="titleClicked(menu.id)"
                class="cursor-pointer underline"
                :class="{ 'font-weight-bold': !hasParent }"
                >{{ menu.label }}</span
            >
        </div>

        <b-collapse v-model="isCollapsed">
            <!-- loop back to current components -->
            <div v-for="menu in children" :key="menu.id">
                <recursive-menu
                    class="pl-4"
                    :ref="`recursive-section-${menu.id}`"
                    :menu="menu"
                    :hasParent="true"
                    @title-clicked="titleClicked"
                />
            </div>
        </b-collapse>
    </div>
</template>

<script>
import RecursiveMenu from "@/components/soap/soap-recursive-menu.vue";
export default {
    name: "RecursiveMenu",
    components: {
        RecursiveMenu
    },
    computed: {
        children() {
            if(!this.menu.data) {
                return [];
            }

            return Object.values(this.menu.data)
        },
        hasChild() {
            return this.children.length > 0;
        }
    },
    props: {
        menu: { type: Object },
        hasParent: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isCollapsed: false
        };
    },
    watch: {},
    methods: {
        titleClicked(elementId) {
            this.$emit("title-clicked", elementId);
        }
    }
};
</script>
<style scoped>
.padding-child {
    padding-left: 23px;
}

.underline:hover {
    text-decoration: underline;
}
</style>
